import { FC, ReactNode } from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';
import { FieldProps, useField } from 'formik';

type CheckboxFieldProps = FieldProps & {
  label: ReactNode;
  submitOnChange?: boolean;
  className?: string;
};

export const CheckboxField: FC<CheckboxFieldProps> = ({ field, label, form, submitOnChange = true, className }) => {
  const [, , helpers] = useField(field.name);

  return (
    <FormControlLabel
      control={
        <Checkbox
          {...field}
          checked={field.value}
          size="small"
          onChange={(event) => {
            helpers.setValue(event.target.checked);

            if (submitOnChange) {
              form.submitForm();
            }
          }}
        />
      }
      label={label}
      className={className}
    />
  );
};
